import Swiper, { A11y, Autoplay, EffectFade, Mousewheel, Navigation, Pagination, Scrollbar } from 'swiper';
Swiper.use([Mousewheel, Navigation, A11y, EffectFade, Autoplay, Pagination, Scrollbar]);
document.addEventListener('DOMContentLoaded', (event) => {
    const sliders = document.querySelectorAll('.ritual .ritual-slider');
    if (sliders.length > 0) {
        [...sliders].forEach((sliderItem) => {
            const options = {
                centeredSlides: true,
                spaceBetween: 20,
                slidesPerView: 2,
            };
            if (sliderItem.dataset.initial) {
                options.initialSlide = parseInt(sliderItem.dataset.initial);
            }
            const swiper = new Swiper(sliderItem, options);
            sliderItem.addEventListener('click', (e) => {
                let item = e.target.closest('.ritual-slide__number-title,.ritual-slide__image');
                let closestSlide = e.target.closest('.ritual-slide');
                if (!!item && closestSlide.classList.contains('swiper-slide-active'))
                    return;
                let screenMiddle = window.innerWidth / 2;
                let clickPosition = e.clientX;
                if (clickPosition > screenMiddle) {
                    swiper.slideNext();
                }
                else {
                    swiper.slidePrev();
                }
            });
            const amIndicator = sliderItem.querySelector('.ritual-am');
            const pmIndicator = sliderItem.querySelector('.ritual-pm');
            swiper.on('slideChange', () => {
                let activeIndex = swiper.activeIndex;
                if (activeIndex > 2) {
                    amIndicator.classList.remove('active');
                    pmIndicator.classList.add('active');
                }
                else {
                    amIndicator.classList.add('active');
                    pmIndicator.classList.remove('active');
                }
            });
            if (parseInt(sliderItem.dataset.initial) > 2) {
                amIndicator.classList.remove('active');
                pmIndicator.classList.add('active');
            }
            /*
            let sliderSlides = sliderItem.querySelectorAll('.ritual-slide');
            sliderSlides.forEach((slide: HTMLElement) => {
              slide.addEventListener('click', () => {
                  let slideIndex = parseInt(slide.dataset.swiperSlideIndex);
                  swiper.slideTo(slideIndex);
              });
            });*/
        });
    }
});
